module.exports = __webpack_public_path__ + "img/lesserpoland_icon.353573d5.png";